module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<a class="inner-element secondary-btn js-autopick">auto pick</a>\n<a class="inner-element primary-btn js-save">save</a>';
}
return __p;
};
